<template>
  <div
    v-if="!objectIsEmpty"
    class="store-card"
  >
    <vue-client-only>
      <span v-if="adaptive.isDesktop">
        Адрес
      </span>
    </vue-client-only>
    <div
      class="metro"
    >
      <div
        v-for="metro in store.metro"
        :key="metro.id"
      >
        <span :style="{backgroundColor: metro.line.color}" />{{ metro.name }}
      </div>
    </div>
    <div class="address">
      {{ store.address }}
    </div>

    <div
      v-if="!cartButton"
      class="phone"
    >
      <span>Телефон:</span> {{ store.phone | noBracesPhone }}
    </div>

    <div class="format">
      <span>Формат:</span> {{ store.workMode || '' }}
    </div>

    <div class="bottom">
      <div
        v-if="closestDate"
        class="date"
      >
        <vue-client-only>
          <span v-if="adaptive.isDesktop">
            Можно забрать
          </span>
        </vue-client-only>
        {{ closestDate }}
      </div>
      <div
        v-else
        class="schedule"
      >
        <span v-if="store.workSchedule.length">
          Часы работы:
        </span>
        {{ store | parseWorkSchedule }}
      </div>

      <to-cart
        v-if="cartButton"
        :product="PRODUCT"
        :sku-id="ACTIVE_SKU.id"
        hide-icons
        hide-notification
        :store-id="store.id"
        text-add="Забрать из магазина"
        class="pickup-button"
        @add="onAddToCart"
      />
      <vue-client-only>
        <div
          v-if="adaptive.isDesktop"
          class="close-button"
          @click="$emit('close')"
        >
          <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
        </div>
      </vue-client-only>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import VueClientOnly from 'vue-client-only';

import clearTimeFromDate from '@/utils/clear-time-from-date';
import IconClose from '../../assets/icons/close.svg';
import ToCart from '../product/to-cart';
import gtmEventsMixin from '@mixins/gtm-events-mixin';
import { ddmmyyyy } from '@/utils/date-to-string';

export default {
  name: 'storeCard',

  components: {
    ToCart,
    VueClientOnly,
  },

  mixins: [gtmEventsMixin],
  
  inject: ['adaptive'],

  props: {
    store: {
      type: Object,
      default: () => {}
    },

    cartButton: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapGetters({
      PRODUCT: 'product/item',
      ACTIVE_SKU: 'product/activeSku',
      CITY: 'user/city',
    }),

    objectIsEmpty() {
      return Object.keys(this.store).length === 0
    },

    closestDate() { // при delayed = false, nearestDate не приходит, поэтому "сегодня" ставим вручную
      let delivery = this.store?.availableSkus?.find(sku => sku.id === this.ACTIVE_SKU.id)?.delivery;
      let delayedDays = delivery?.nearestDate ?
          (clearTimeFromDate(new Date(delivery.nearestDate)).setHours(0) - clearTimeFromDate(new Date()).setHours(0)) / 86400000
          : 0;

      if (delivery?.delayed === false) {
        return 'Сегодня'
      } else if (delayedDays === 1) {
        return 'Завтра'
      } else {
        return delivery?.nearestDate
          ? ddmmyyyy(new Date(delivery.nearestDate))
          : '';
      }
    },
  },

  icons: {
    IconClose
  },

  methods: {
    onAddToCart() {
      this.gtmEvents.addToCartOnMap({
        storeId: this.store.id,
        productCode: this.PRODUCT?.code,
        cityName: this.CITY?.name,
      });
    },
  },
};
</script>

<style lang="scss">
.store-card {
  .metro,
  .phone,
  .format,
  .schedule {
    font-size: 12px;
    line-height: 20px;
  }

  .metro,
  .metro > div {
    display: flex;
  }

  .metro {
    flex-wrap: wrap;
  }

  .metro > div {
    align-items: center;
    margin-right: 12px;

    & > span {
      display: block;
      width: 8px;
      height: 8px;
      margin-right: 8px;
      border-radius: 50%;
    }
  }

  .address {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }

  .phone,
  .format,
  .schedule {
    span {
      color: $gray;
    }
  }

  .phone {
    margin-top: 8px;
  }

  .format {
    margin-top: 2px;
  }

  .bottom {
    margin-top: 2px;
  }

  .date {
    font-size: 12px;
    line-height: 20px;
  }

  .pickup-button {
    margin-top: 8px;
  }
}

@include breakpoint("tablet") {
  .store-card {
    border-radius: 4px;
  }
}

@include breakpoint("desktop") {
  .store-card {
    position: absolute;
    top: 32px;
    left: 32px;
    width: 320px;
    padding: 32px 24px 24px 24px;
    border-radius: 4px;
    box-shadow: 0 8px 40px rgba(51, 51, 51, .16);
    background-color: #fff;
    z-index: 10;

    & > span {
      font-size: 14px;
      line-height: 16px;
      color: $gray;
    }

    .metro {
      margin-top: 8px;
    }

    .address {
      font-size: 16px;
      line-height: 24px;
    }

    .format {
      margin-top: 4px;
    }

    .metro,
    .phone,
    .format,
    .schedule {
      font-size: 14px;
      line-height: 24px;
    }

    .phone,
    .format,
    .schedule {
      display: flex;
      flex-direction: column;

      span {
        line-height: 16px;
      }
    }

    .bottom {
      margin-top: 14px;
      padding-top: 15px;
      border-top: 1px solid $gray_lu;
    }

    .date {
      font-size: 14px;

      span {
        display: block;
        margin-bottom: 5px;
        color: $gray;
        line-height: 16px;
      }
    }

    .pickup-button {
      margin-top: 32px;
    }

    .close-button {
      position: absolute;
      top: 14px;
      right: 14px;
      width: 24px;
      height: 24px;
      color: $gray_lu;
      cursor: pointer;
    }
  }
}
</style>
